<template>
  <div class="flex flex-col my-4 mx-0 p-4 bg-[#f8f8f8] rounded app">
    <h3>Try it out</h3>
    <h4>Message</h4>
    <div class="flex mb-4">
      <textarea v-model="body" class="base-font border grow h-[150px] resize-y p-2" />
    </div>

    <h4>Data</h4>
    <div class="box flex flex-col rounded-lg py-2 px-4 mb-4">
      <div class="flex flex-row">
        <div class="grow basis-0"><b>Unicode is Required?</b></div>
        <div class="grow-2 basis-0">
          <v-icon
            :style="{ color: unicodeRequired ? 'green' : 'red' }"
            :name="unicodeRequired ? 'check-circle-solid' : 'close-circle-solid'"
          />
        </div>
      </div>
      <div class="separator line" />
      <div class="flex flex-row">
        <div class="grow basis-0"><b>Length</b></div>
        <div class="grow-2 basis-0" v-html="smsComposition" />
      </div>
    </div>

    <h4>Parts</h4>
    <div class="box flex flex-col rounded-lg py-2 px-4 mb-4">
      <div v-for="(message, index) in messages" :key="index">
        <div class="flex flex-row">
          <div class="grow basis-0 base-font flex items-center">
            <b>Part {{ index + 1 }}</b>
          </div>
          <div class="grow-2 basis-0">
            <span v-if="messages.length > 1" class="pill base-font py-1 px-2 rounded mr-2">User Defined Header</span>
            <code class="normal break-all">
              {{ message }}
            </code>
          </div>
        </div>
        <div v-if="index + 1 !== messages.length" class="separator line" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { VIcon } from '@vonage/vivid-vue';
import CharacterCounter from './character_counter';

const body = ref<string>(
  'It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness, it was the epoch of belief, it was the epoch of incredulity, it was the season of Light, it was the season of Darkness, it was the spring of hope, it was the winter of despair, we had everything before us, we had nothing before us, we were all going direct to Heaven, we were all going direct the other way in short, the period was so far like the present period, that some of its noisiest authorities insisted on its being received, for good or for evil, in the superlative degree of comparison only.'
);

const smsInfo = computed(() => new CharacterCounter(body.value).getInfo());
const messages = computed(() => smsInfo.value.messages);
const unicodeRequired = computed(() => smsInfo.value.unicodeRequired);

function pluralize(singular: string, count: number) {
  if (count === 1) {
    return singular;
  }
  return `${singular}s`;
}

const smsComposition = computed(() => {
  const count = smsInfo.value.charactersCount;
  const characters = pluralize('character', count);
  const messagesLength = messages.value.length;
  const parts = pluralize('part', messagesLength);

  return `${count} ${characters} sent in ${messagesLength} message ${parts}`;
});
</script>

<style lang="scss" scoped>
.app {
  border: 1px solid #d0d0d0;
}
h3,
h4 {
  margin-left: 0 !important;
}
.box {
  border: 1px solid var(--vvd-color-neutral-300);
}
textarea {
  outline-color: var(--dp-color-cta-500);
}
.pill {
  color: var(--vvd-color-canvas);
  background-color: var(--dp-color-cta-500);
}
.base-font {
  font: var(--vvd-typography-base);
}
</style>
